module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt.711a0226055653e1f059e244785746ee.png";